function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st2Electrons{fill:#747475;}\n\t.st1Electrons{fill:#F99F1E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st2Electrons",
  d: "M158.4,105.6c-0.2,0-0.5,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.1c-1.8,0-3.8-0.3-5.7-1l-0.7-0.2l-0.2,0.7 c-8.2,29.6-34.6,50.3-64.1,50.3c-29.7,0-56.1-20.8-64.2-50.5l-0.2-0.7l-1.2,0.4c-0.6,0.2-1.1,0.4-1.7,0.5c-1.4,0.3-2.8,0.5-4.2,0.5 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.5-0.1l-0.9,0l0.2,0.9c9.1,32.6,39.1,55.3,72.8,55.3c33.8,0,63.7-22.8,72.8-55.4l0.3-0.9 L158.4,105.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st2Electrons",
  d: "M159.3,66.6c-8.9-33-38.9-56.1-73-56.1c-34.1,0-64.1,23-73,56L13,67.4l0.9-0.1c2.4-0.1,4.8,0.2,7.1,1l0.7,0.2 l0.2-0.7c7.9-30.1,34.4-51.2,64.4-51.2c29.9,0,56.4,21,64.3,51.1l0.2,0.7l0.7-0.2c0.2-0.1,0.4-0.1,0.6-0.2c0.3-0.1,0.6-0.2,0.9-0.3 c1.7-0.4,3.6-0.5,5.7-0.3l0.9,0.1L159.3,66.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1Electrons",
  d: "M144.3,78.4c-2.2,3.4-2.9,7.4-2,11.4c0.9,3.9,3.2,7.3,6.6,9.5c2.5,1.6,5.2,2.4,8.1,2.4c1.1,0,2.2-0.1,3.3-0.4 c3.9-0.9,7.3-3.2,9.5-6.6c2.2-3.4,2.9-7.4,2-11.4c-0.9-3.9-3.2-7.3-6.6-9.5c-3.4-2.2-7.4-2.9-11.4-2C149.9,72.7,146.5,75,144.3,78.4 z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1Electrons",
  d: "M6.8,99.2c2.5,1.6,5.2,2.4,8.1,2.4c1.1,0,2.2-0.1,3.3-0.4c3.9-0.9,7.3-3.2,9.5-6.6c2.2-3.4,2.9-7.4,2-11.4 c-0.9-3.9-3.2-7.3-6.6-9.5c-3.4-2.2-7.4-2.9-11.4-2c-3.9,0.9-7.3,3.2-9.5,6.6c-2.2,3.4-2.9,7.4-2,11.4C1.1,93.7,3.4,97.1,6.8,99.2z"
});

var SvgEletrons = function SvgEletrons(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 172 172",
    style: {
      enableBackground: "new 0 0 172 172"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEletrons, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eletrons.f35fc614.svg";
export { ForwardRef as ReactComponent };